export const EVENT_NAME = {
  SOCIAL_SHARE_MODAL_CLOSED: "Social Share Modal Closed",
  SHARE_BET_CTA_CLICKED: "Share Bet CTA Clicked",
  SOCIAL_SHARE_MODAL_OPENED: "Social Share Modal Opened"
};
